exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntable[data-v-3fb63e50] {\n  margin-bottom: 2rem;\n  border-bottom: 1px solid #cccccc;\n}\ntable tr > th[data-v-3fb63e50],\n  table tr > td[data-v-3fb63e50] {\n    border-color: #cccccc;\n}\ntable tr > th[data-v-3fb63e50]:nth-of-type(1) {\n    width: 10%;\n}\ntable tr > th[data-v-3fb63e50]:nth-of-type(2) {\n    width: 58%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3fb63e50","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./src/components/parts/QuantityCheckTable.vue
// module id = KrXQ
// module chunks = 1